import { ArdRequestLifecycle, MaybeArdQueryParams } from '../../types/queryParams';

export enum ArdRegionReportSessionOutcome {
  Success = 'success',
  Failed = 'failed',
  Timeout = 'timeout',
  Canceled = 'canceled',
}

export enum ArdRegionReportFailureStage {
  Submit = 'submit',
  PollStatus = 'poll_status',
  FetchReport = 'fetch_report',
  Render = 'render',
}

export enum ArdRegionReportEntryPoint {
  CreatedRegion = 'created_region',
  NewRegion = 'new_region',
}

export interface ArdRegionReportSessionOptions {
  error?: string;
  errorType?: string;
  failureStage?: ArdRegionReportFailureStage;
}

export interface ReportArdRegionReportSessionParams {
  activityExists: boolean;
  lifecycle: ArdRequestLifecycle;
  options?: ArdRegionReportSessionOptions;
  outcome: ArdRegionReportSessionOutcome;
  queryParams: MaybeArdQueryParams;
  sessionStartedAt: number;
}

export interface ReportArdRegionReportRequestStartedParams {
  activityExists: boolean;
  queryParams: MaybeArdQueryParams;
}